/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Plugins_Contact_Support_EmailInputs */

const en_team_manager_plugins_contact_support_email = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@closedcaptioncreator.com`)
};

const fr_team_manager_plugins_contact_support_email = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@closedcaptioncreator.com`)
};

const de_team_manager_plugins_contact_support_email = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@closedcaptioncreator.com`)
};

const it_team_manager_plugins_contact_support_email = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@closedcaptioncreator.com`)
};

const ru_team_manager_plugins_contact_support_email = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@closedcaptioncreator.com`)
};

const es_team_manager_plugins_contact_support_email = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`soporte@closedcaptioncreator.com`)
};

const zh_cn2_team_manager_plugins_contact_support_email = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@closedcaptioncreator.com`)
};

const ja_team_manager_plugins_contact_support_email = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@closedcaptioncreator.com`)
};

const hi_team_manager_plugins_contact_support_email = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@closedcaptioncreator.com`)
};

const pt_pt2_team_manager_plugins_contact_support_email = /** @type {(inputs: Team_Manager_Plugins_Contact_Support_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`support@closedcaptioncreator.com`)
};

/**
* | output |
* | --- |
* | "support@closedcaptioncreator.com" |
*
* @param {Team_Manager_Plugins_Contact_Support_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_plugins_contact_support_email = /** @type {((inputs?: Team_Manager_Plugins_Contact_Support_EmailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Plugins_Contact_Support_EmailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_plugins_contact_support_email(inputs)
	if (locale === "de") return de_team_manager_plugins_contact_support_email(inputs)
	if (locale === "it") return it_team_manager_plugins_contact_support_email(inputs)
	if (locale === "ru") return ru_team_manager_plugins_contact_support_email(inputs)
	if (locale === "es") return es_team_manager_plugins_contact_support_email(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_plugins_contact_support_email(inputs)
	if (locale === "ja") return ja_team_manager_plugins_contact_support_email(inputs)
	if (locale === "hi") return hi_team_manager_plugins_contact_support_email(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_plugins_contact_support_email(inputs)
	return en_team_manager_plugins_contact_support_email(inputs)
});